import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { EmployeeService } from '../../services/employees.service';
import { UtilService } from '../../services/util.service';
import {
    EmployeeRole
} from '../../models/models';

@Component({
    selector: 'employee-role-grid',
    templateUrl: './employee-role-grid.component.html',
    standalone: false
})
export class EmployeeRoleGrid implements OnInit {
    @ViewChild(GridComponent, { static: false }) public tableGrid!: GridComponent;

    public isAssign: boolean = false;

    public tableID: number = 0;
    public recordName: string = "Employee Role";
    public tableList: EmployeeRole[] = [];
    private tableIDName: string = "employeeRoleId";

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: this.tableIDName }] };

    constructor(private employeeService: EmployeeService, private utilService: UtilService, private ngZone: NgZone) {
    }

    ngOnInit() {
        this.getTableList();
    }

    private getTableList() {
        this.utilService.isLoading = true;
        this.employeeService.getEmployeeRoles().subscribe(result => {
            this.utilService.isLoading = false;
            this.tableList = result.resultCollection;
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.tableList = orderBy(this.tableList, this.gridState.sort);

        this.gridData = process(this.tableList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.tableGrid == null) return;
            this.tableGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public assign(tableID: number) {
        this.tableID = tableID;
        this.isAssign = true;
    }

    public cancelEdit() {
        this.isAssign = false;
        this.getTableList();
    }
}
